import { queueChecklistSectionChanges } from 'serviceWorker/services/checklistSections/queueChecklistSectionChanges';
import { channelServer, ChannelUnsubscribe } from 'shared/channels';
import { checklistSectionContract } from 'shared/domain/checklistSection/checklistSectionContract';

/** Answers checklist section changes once queued; their outcome follows as an event with the change's `uniqueId`. */
export function serveChecklistSectionRequests(): ChannelUnsubscribe {
  return channelServer.handle(checklistSectionContract, queueChecklistSectionChanges);
}
